<!-- paySuccess -->
<template>
  <div class="paySuccess" :class="{ inApp: $root.$data.isApp, vip: memberPackage }">
    <template v-if="!$root.zsbMini">
      <template v-if="isContainEbook == 1">
        <template v-if="!memberPackage">
          <div v-if="this.source !== 1">
            <!-- <common-title titleName="支付成功" :beforeExec="goBackConfirm" :zIndex="1000"></common-title> -->
            <i v-if="!$root.$data.isApp" class="closeButton" @click="goOrderDetail"></i>
            <success-part
              v-if="textData.stepText && initOver"
              :successTypeText="successTypeText"
              :stepText="textData.stepText"
              :expireType="expireType"
              :invalidTime="invalidTime"
              :containPackage="containPackage"
              :productInfo="productInfo"
            />
            <section v-else>
              <p class="errorTips">{{ errorTips }}</p>
            </section>
            <section v-if="textData.cardTitle" class="buttonPart">
              <div :class="['addCard', { addCardWechat: platform === 2 }]">
                <img class="qrcode" v-if="qrcode" :src="qrcode" alt />
                <div class="cardText">
                  <p class="cardTitle">{{ textData.cardTitle }}</p>
                  <p
                    v-if="textData.cardSubTitle"
                    class="cardTitle"
                  >{{ textData.cardSubTitle }}{{ textData.cardSubText }}</p>
                  <p v-if="textData.cardTips" class="cardTips">{{ textData.cardTips }}</p>
                  <span
                    v-if="this.$root.miniprogram || isWechatBrowser"
                    class="cardTips mini"
                  >{{ textData.miniButtonText }}</span>
                  <button
                    v-if="textData.buttonText && !this.$root.miniprogram & !isWechatBrowser"
                    class="addButton"
                    @click="addHanlde"
                  >{{ textData.buttonText }}</button>
                </div>
              </div>
              <div class="buttonGroup" v-if="depositStatus !== 4">
                <button
                  @click="goCourse"
                  class="goCourse"
                >{{ isContainCurriculum ? '查看课程' : '查看订单' }}</button>
                <button v-if="bindInfo === false" @click="goOrderDetail" class="bindInfo">完善订单信息</button>
              </div>
              <div class="buttonGroup" v-else>
                <button @click="goOrderDetail" class="bindInfo">查看定金详情</button>
              </div>
            </section>
            <!-- 真题实战相关课程 -->
            <section v-if="VideoAnalysiShow">
              <video-analysis :videoSubjectName="videoSubjectName" />
            </section>
            <!-- 已解锁的题库 -->
            <section v-if="subjectArr.length">
              <question-bank-part :subjectArr="subjectArr" />
            </section>
            <!-- 推荐课程 -->
            <section v-if="recommendList.length" class="recommendPart">
              <p class="recommendTitle">推荐课程</p>
              <ul class="courseList">
                <li
                  class="courseInfo"
                  v-for="(recommendCourse, index) in recommendList"
                  :key="index"
                >
                  <course-card :courseInfo="recommendCourse" />
                </li>
              </ul>
            </section>
            <!-- 直播弹窗 -->
            <MultipleLiveCourse :videoList="videoList" v-if="showLive" @closeLive="closeLive" />
          </div>
          <!-- 退换课 -->
          <div class="returnClass" v-else>
            <div class="sIcon"></div>
            <p>系统正在为您开通新课程...</p>
            <button class="checkOrder" @click="checkOrder()">查看新订单</button>
            <button class="checkCourse" @click="checkCourse()">查看售后详情</button>
          </div>
          <!--  -->
          <div class="form22" v-if="containPackage === 0">
            <h1 class="title">
              <img src="../../assets/img/payment/note.png" alt />
              <span>注意事项</span>
            </h1>
            <div class="form22-box">
              <div class="txt-box">
                <h2>查看该课程时：</h2>
                <p class="border">
                  您需要在【{{
                  $root.$data.isApp ? '学习' : '我的课程'
                  }}】界面右上角选择【23考研学生】后，才可以查看您所购买的课程。
                </p>
              </div>
              <div class="txt-box">
                <h2>查看该订单时：</h2>
                <p>您需要在【我的】界面左上角选择【23考研学生】后，进入我的订单模块才可以查看您购买课程的订单。</p>
              </div>
            </div>
          </div>

          <div class="learningToRemind" v-if="containPackageCommunity === 1">
            <h1 class="title">
              <img src="../../assets/img/payment/sigh.png" alt />
              <span>注意事项</span>
            </h1>
            <div class="addRingGroup">
              <div>
                <h2>加入班级群和同学们一起学习讨论吧~</h2>
                <h3 @click="addGroupList">前往添加</h3>
              </div>
              <img class="bgImg" src="../../assets/img/payment/sigh01.png" alt />
            </div>
          </div>

          <img
            class="member_empty_icon"
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/pay_success_member.png"
            alt
            v-if="amountSmall"
            @click="goMemberCenter"
          />

          <img
            class="like_icon"
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/pay_success_like.png"
            alt
            v-if="courseInfoData.length != 0 && amountSmall"
          />

          <div class="like_list" v-if="courseInfoData.length != 0 && amountSmall">
            <ul class="courseList">
              <li v-for="(item, keys) in courseInfoData" :key="keys">
                <CombinationCard
                  v-if="item.setType === 1"
                  :item="item"
                  :key="keys"
                  @click.native="gioEvent(item)"
                />
                <HotCourseCard v-else :item="item" :key="keys" @click.native="gioEvent(item)" />
              </li>
            </ul>
          </div>
        </template>
        <template v-if="memberPackage">
          <div class="vip-container">
            <common-title :bcColor="'#F9F9F9'" titleName="支付成功" :zIndex="1000" @goBack="goBack"></common-title>
            <div class="status">
              <img src="../../assets/img/payment/pay_success.png" alt />
              <p>支付成功</p>
            </div>
            <div class="profit">
              <h2>恭喜，解锁{{ memberLevel === 30 ? '高级' : '基础' }}会员权益</h2>
              <div class="list">
                <div v-for="(item, index) in profitList" :key="index">
                  <img :src="item.icon" alt />
                  <p>{{ item.title }}</p>
                </div>
              </div>
              <button class="lookProfit" @click="lookProfit">查看权益</button>
            </div>
            <div class="vip-shequn-code">
              <div class="code">
                <img :src="codeUrl" alt />
              </div>
              <div class="content">
                <div class="title">添加老师微信</div>
                <div class="info">专属指导，学习快人一步！</div>
                <div class="tip" v-if="$root.miniprogram">
                  <img
                    src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/member/member_paySucc_shequn_tip.png"
                    alt
                  />
                </div>
                <div class="tipApp" v-if="!$root.miniprogram">
                  <img
                    src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/member/member_paySucc_shequn_tip_app.png"
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="isContainEbook == 2">
        <div class="ebook" v-if="this.source !== 1">
          <img src="../../assets/img/payment/pay_success.png" alt />
          <div class="msg">订单支付成功！</div>
          <div class="lookBook" @click="openEbook">查看图书</div>
        </div>
        <div v-else class="returnClass">
          <div class="sIcon"></div>
          <p>系统正在为您开通新课程...</p>
          <button class="checkOrder" @click="checkOrder()">查看新订单</button>
          <button class="checkCourse" @click="checkCourse()">查看售后详情</button>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="zsb">
        <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-upgrade-mini/home/pay.png" alt />
        <p>订单支付成功！</p>
        <button @click="goCourse">查看课程</button>
      </div>
    </template>
    <CouponPop
      v-if="couponOverlay"
      @closeOverlay="closeOverlay"
      :wholeGiftlist="wholeGiftlist"
      :giftMaterialList="giftMaterialList"
      :giftMemberList="giftMemberList"
      :isOrderAddres="isOrderAddres"
    />
    <!-- 开播提醒弹框 -->
    <RemindBox v-if="isRemindBox" @closeRemindBox="closeRemindBox" />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import CourseCard from '@/components/course/CourseCard.vue';
import { successTextConfig } from '@/assets/js/payConfig';
// eslint-disable-next-line import/no-cycle
import { reqReplaceDetail } from '@/api/personal/returnClass';
import { getTaskApi } from '@/api/learningGuidePage/index';
import RemindBox from '@/components/remindBox/index.vue';
import { reqPackageName } from '@/api/courseDetail/shoppingCar/shoppingCar';
import {
  reqPaySuccessInfo,
  reqCourseStartStatus,
  reqGetDepositInfo,
  reqCouponGiftSuc,
  reqGetSubject,
  getVideoAnalysis,
} from '@/api/pay';
import { reqCourseDetail } from '@/api/courseDetail/index';
import { miniSchemeUrl } from '@/utils/common';
import { reqOpenCourseLive, reqTypeList } from '@/api/home';
import MultipleLiveCourse from '../../components/multipleLiveCourse/index.vue';
import SuccessPart from './paySuccessComponents/successPart.vue';
import CouponPop from './couponPop/couponPop.vue';
import QuestionBankPart from './paySuccessComponents/questionBankPart.vue';
import VideoAnalysis from './paySuccessComponents/videoAnalysis.vue';
import { judgmentPlatform, isEbookShowUpdateToast, goApp } from '@/utils/tools';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import { reqProducts, reqMajorAd } from '@/api/home';
import { deepCopy } from '@/utils/tools';

export default {
  components: {
    CourseCard,
    SuccessPart,
    MultipleLiveCourse,
    CouponPop,
    QuestionBankPart,
    VideoAnalysis,
    RemindBox,
    HotCourseCard,
    CombinationCard,
  },
  data() {
    return {
      textData: {
        stepText: '',
        cardTitle: '',
        cardSubTitle: '',
        cardSubText: '',
        cardTips: '',
        goCourseText: '',
        buttonText: '',
      },
      recommendList: [],
      platform: '',
      accountType: '',
      buttonUrl: '',
      qrcode: '',
      userAccount: '',
      initOver: false,
      errorTips: '',
      successTypeText: '',
      bindInfo: true,
      productInfo: [],
      expireType: NaN,
      invalidTime: '',
      requestTimes: 0,
      showLive: false,
      source: Number(this.$route.query.source), // 1    退换课来源
      isOrderAddres: this.$route.query.isOrderAddres,
      returnNewOrder: '', // 退还课生成的新订单号
      returnLoad: false,
      isContainCurriculum: false, // 订单中是否有订单含有课表
      containPackage: 1, // 订单是否包含套餐 1包含 0 不包含
      depositStatus: 0, // 定金支付状态 1-待付定金 2-定金单已取消 3-定金单超时关闭 4-待付尾款（已付定金） 5-尾款已支付 6-尾款已关闭（超时未支付） 7-尾款已取消
      containPackageCommunity: 0, // 是否包含套餐社群 1包含 0 不包含
      couponOverlay: false, // 买课赠券弹窗
      wholeGiftlist: null, // 赠券列表
      giftMaterialList: null, // 赠品实物列表
      giftMemberList: null,
      groupEntryMode: 3, // 微信加群方式 1：普通(保存二维码)，2：微伴  3：跳转小程序
      communityId: '', // 社群ID
      subjectArr: [], // 解锁的题库列表
      VideoAnalysiShow: false,
      videoSubjectName: [],
      isRemindBox: false, // 开播提醒弹框
      memberPackage: false,
      memberLevel: 0,
      profitList: [],
      isWechatBrowser: /MicroMessenger/i.test(navigator.userAgent),
      // isWechatBrowser:true
      isContainEbook: 0,
      styleTemplate: '',
      courseInfoData: [],
      amountSmall: false,
    };
  },
  computed: {
    ...mapState(['userInfo', 'allAcvitity']),
  },
  mounted() {
    // ios手机支付成功后页面登录丢失（未初始化页面） 这里是临时方案
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken && this.$root.isApp && judgmentPlatform() === 'ios') {
      window.location.reload();
    }

    this.successTypeText = this.$route?.query?.type ? '领取' : '支付';
    document.title = `${this.successTypeText}成功`;
    // 普通订单 或者 定金
    if (this.source !== 1) {
      this.getSuccessInfo();
    } else {
      // 退换课
      this.checkNewOrder();
    }
    window.examSeasonType = () => {
      // this.getExamSeason(type);
    };

    this.getSubjectArr();
    this.getBuyCourseGift();
    reqTypeList('MEMBER_ASSOCIATION').then(res => {
      console.log(res, 'code');
      const { value } = res.data?.[0] || {};
      this.codeUrl = value;
    });
    this.getCourseAd();
  },

  destroyed() {
    this.clearStorage();
  },
  methods: {
    goMemberCenter() {
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: `${window.location.origin}/ark/personalCenter/member?hiddenNavigationBar=1`,
          },
          false,
        );
        return;
      }
      this.$router.push({
        path: '/personalCenter/member',
        // path: '/personalCenter/member?isHideTitle=true',
      });
    },
    async getCourseAd() {
      this.showLoad = true;
      this.isEmpty = false;
      const { code, data } = await reqMajorAd(592);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      }
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach(child => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const res = allProductIds.length ? await reqProducts(allProductIds, endPoint) : {};
      const res1 = allPackageIds.length ? await reqCombinationlist(0, endPoint, allPackageIds) : {};
      const resCourse = this.resetProductData(res.data || [], 2);
      const resPackage = this.resetCoursePackage(res1.data || []);
      const allCourse = [];
      recommendContentVOList.forEach(child => {
        const findRes = [...resCourse, ...resPackage].find(course => {
          const id = child.recommendType === 0 ? course.productId : course.packageId;
          return id === child.productId;
        });
        // eslint-disable-next-line no-unused-expressions
        findRes && allCourse.push(findRes);
      });
      this.courseInfoData = allCourse;
    },
    // 自定义数据格式
    resetProductData(courseList) {
      courseList.forEach(item => {
        const copyItem = deepCopy(item);
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map(teacher => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          item.sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice) +
              Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return courseList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach(item => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount &&
          item.sellPrice > 0 &&
          !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    showRemindBox() {
      // 打开开播提醒
      this.isRemindBox = true;
    },
    closeRemindBox() {
      // 关闭开播提醒
      this.isRemindBox = false;
    },
    // 遍历订单，判断是否有课表，确定 查看订单 按钮状态
    isContainCurriculumFun(val) {
      if (!val.length > 0) {
        return;
      }
      val.forEach(item => {
        if (item.containCurriculum) {
          this.isContainCurriculum = true;
        }
      });
    },
    goTiktokActivity(response) {
      const { orderProducts } = response.data;
      const xxlPageUrl = localStorage.getItem('xxlPageUrl');
      if (xxlPageUrl) {
        window.location.href = xxlPageUrl;
        return;
      }
      setTimeout(() => {
        orderProducts.forEach(item => {
          if (window.tiktokCourseIDs) {
            const [obj] = window.tiktokCourseIDs.filter(son => son.productId === item.productId);
            if (obj) window.location.href = obj.url;
          }
        });
      }, 500);
    },
    // 真题实战相关
    async handleVideoAnalysis(response) {
      const { orderProducts } = response.data;
      const skuList = orderProducts.map(item => item.productSkuId);
      const { data } = await getVideoAnalysis(skuList);
      if (data && data?.length > 0) {
        this.videoSubjectName = data.map(item => item.subjectName);
        this.VideoAnalysiShow = true;
      }
    },
    async getSuccessInfo() {
      console.log(333333333);
      let response = null;
      if (this.source === 3 || this.source === 4) {
        response = await reqGetDepositInfo({
          depositOrderNo: this.$route.query.orderNo,
        });
        this.depositStatus = response?.data?.status;
      } else {
        response = await reqPaySuccessInfo({
          orderNo: this.$route.query.orderNo,
        });
        console.log(444444444, response);
      }
      if (response?.code) {
        this.errorTips = `${response?.msg}，请确认订单号是否正确`;
        this.$toast(`因${response?.msg}，获取成功信息失败`);
      } else {
        this.handleVideoAnalysis(response);
        this.goTiktokActivity(response); // 判断是否是抖音信息流
        const responseData = response?.data?.bindCommunityRespVOs?.[0] || {};
        this.platform = responseData.platform || '';
        this.accountType = responseData.accountType || '';
        this.groupEntryMode = responseData.groupEntryMode || 3;
        this.buttonUrl = responseData.linkUrl || '';
        this.bindInfo = response?.data?.bindInfo;
        this.amountSmall = response?.data?.amount < 1300;
        this.containPackage = response.data.containPackage;
        this.containPackageCommunity = response.data.containPackageCommunity;
        this.isContainEbook = response.data.isContainEbook ? 2 : 1;
        if (response.data.orderProducts?.length > 1 || !response?.data?.bindCommunityRespVOs?.[0]) {
          this.platform = 2;
          this.accountType = 3;
          this.groupEntryMode = 3;
          this.memberPackage = response?.data?.packageType === 2;
          this.memberLevel = response?.data?.memberLevel;
          this.getTypeList(this.memberLevel);
          this.qrcode =
            response?.data?.officialWeiXin ||
            'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/1615366533993613908.png';
        } else {
          this.qrcode = responseData.qrcode || '';
          this.communityId = responseData.communityId || '';
        }
        // const textData = this.containPackage'
        let textData;
        if (this.groupEntryMode === 3 && this.platform === 2) {
          textData =
            response.data.orderProducts.length > 1
              ? successTextConfig['2-3']
              : successTextConfig[`${this.platform}-${this.accountType}-${this.groupEntryMode}`] ||
                successTextConfig['2-3'];
        } else {
          textData =
            response.data.orderProducts.length > 1
              ? successTextConfig['2-3']
              : successTextConfig[`${this.platform}-${this.accountType}`] ||
                successTextConfig['2-3'];
        }
        Object.assign(this.textData, textData);
        this.$set(this.textData, 'cardSubText', this.accountType === 2 ? responseData.account : '');
        this.userAccount = responseData.account;
        this.productInfo = response?.data?.orderProducts;
        this.isContainCurriculumFun(this.productInfo);
        this.expireType = this.productInfo[0].expireType || NaN;
        this.invalidTime = this.productInfo[0].invalidTime || '';
        if (this.productInfo.length === 1) {
          this.getCourseStartStatus(true);
          // 请求直播
          this.getCatalog();
        }
      }
      this.initOver = true;
      localStorage.removeItem('miniBeforePageName');
    },
    async goCourse() {
      await this.getCourseStartStatus();
      console.log(this.productInfo);
      const { productId: courseId, startId } = this.productInfo[0];
      if (!startId) {
        this.$toast('开课中，请稍等');
        return;
      }
      // 无课表的情况下，跳转订单页；有课表时，h5打开下载app弹窗
      if (this.isContainCurriculum) {
        if (this.$root.$data.isApp) {
          if (this.productInfo.length > 1) {
            // 课程列表页
            this.$sendToApp(
              'goLearnCenterPage',
              {
                courseId,
              },
              false,
            );
          }
          if (this.productInfo.length === 1) {
            if (!startId) {
              this.$toast('开课中，请稍候');
              this.getCourseStartStatus();
            } else {
              // 导学页
              this.$sendToApp(
                'goDirectoryPage',
                {
                  courseId: startId,
                },
                false,
              );
            }
          }
        } else if (this.productInfo.length > 1) {
          // 课程列表页
          if (this.$root.miniprogram) {
            wx.miniProgram.navigateTo({ url: '/myCourse/courseList/index' });
            return;
          }
          this.$router.push({
            path: '/personalCenter/mycourseList',
          });
        } else {
          const res = await this.entranceTask(startId);
          if (res === 'unFinished') {
            if (this.$root.miniprogram) {
              this.$toast('请前往app完成入学任务后，即可查看课程视频');
            } else {
              this.$router.push({
                path: '/entranceTask',
                query: {
                  id: startId,
                },
              });
            }
          } else if (res === 'finished') {
            if (this.$root.miniprogram) {
              wx.miniProgram.navigateTo({
                url: `/myCourse/learningGuide/index?catalogId=${startId}`,
              });
            } else {
              this.$router.push({
                path: '/learningGuide',
                query: {
                  catalogId: startId,
                },
              });
            }
          }
        }
      } else {
        this.goOrderDetail();
      }
    },
    async entranceTask(id) {
      const { code, data } = await getTaskApi(id);
      if (code === 0) {
        const {
          agreementId,
          agreementDone,
          examId,
          examDone,
          examinationFlag,
          examinationDone,
        } = data;
        this.examId = examId;
        if (
          (agreementId && !agreementDone) ||
          (examId && !examDone) ||
          (examinationFlag && !examinationDone)
        ) {
          return 'unFinished';
        }
        return 'finished';
      }
      return 'err';
    },
    getCourseStartStatus(isInit = false) {
      if (isInit && this.requestTimes > 5) return;
      this.requestTimes += 1;
      reqCourseStartStatus({
        productId: this.productInfo[0].productId,
      }).then(response => {
        if (response.code) {
          this.$toast(response.msg || response?.errorData?.[0]?.msg || '查询开课状态失败');
        } else {
          const startId = response.data?.[0].id;
          if (startId) this.productInfo[0].startId = startId;
          else if (isInit) {
            let timer = setTimeout(() => {
              this.getCourseStartStatus(isInit);
              clearTimeout(timer);
              timer = null;
            }, 1000);
          }
        }
      });
    },
    async openMiniPage(communityId) {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: `/subPackages/codePage/codePage?communityId=${communityId}`,
        });
      } else if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/codePage/codePage?communityId=${communityId}`,
        });
      } else {
        const schemeLink = await miniSchemeUrl(
          'wxdb89cfa2bb60f779',
          '/subPackages/codePage/codePage',
          `communityId=${communityId}`,
        );
        window.location.href = schemeLink;
      }
    },
    addHanlde() {
      if (this.$root.miniprogram) return;
      const { communityId } = this;
      if (this.platform === 2 && this.groupEntryMode === 3) {
        this.openMiniPage(communityId);
        return;
      }

      const isQQ = this.platform === 1; // 是否微信
      const isPersonal = this.accountType === 2; // 是否是个人
      if (this.$root.$data.isApp) {
        // 判断是否是内嵌app
        if (isQQ) {
          if (isPersonal) {
            this.$sendToApp('addQQ', {
              QQNum: this.userAccount,
            });
          } else {
            this.$sendToApp('addQQGroup', {
              url: this.buttonUrl,
            });
          }
        } else if (!isPersonal || (this.platform === 2 && this.accountType === 3)) {
          this.$sendToApp('addWechatGroup', { QRCodeUrl: this.qrcode }, false);
        } else {
          this.$sendToApp('addWechat', {
            WechatNum: this.userAccount,
          });
        }
      } else if (this.accountType === 3 || (!isQQ && !isPersonal)) {
        // 默认公众号或微信群，截图保存二维码
        this.$toast(`请截图保存二维码到${isQQ ? 'QQ' : '微信'}添加`);
      } else if (!isQQ && isPersonal) {
        // 微信个人，复制助教微信号并添加
        this.$copyText(this.textData.cardSubText)
          .then(() => {
            this.$toast(`复制成功，前往${isQQ ? 'QQ' : '微信'}添加`);
          })
          .catch(() => {
            this.$toast('复制失败');
          });
      } else if (this.buttonUrl) {
        // qq账号，跳转链接
        window.open(this.buttonUrl);
      }
    },
    goOrderDetail() {
      const questionCallBackUrl = sessionStorage.getItem('questionCallBackUrl');
      if (this.VideoAnalysiShow && questionCallBackUrl) {
        if (questionCallBackUrl) {
          window.location.replace(questionCallBackUrl);
        }
        return;
      }
      // 定金已支付
      if (this.depositStatus === 4) {
        this.$router.replace({
          path: '/personalCenter/handselDetail',
          query: { handselOrder: this.$route.query.orderNo },
        });
      } else if (this.depositStatus === 5) {
        // -尾款已支付
        if (this.$root.$data.isApp) {
          this.$sendToApp('goToMyOrderList', '', false);
        } else {
          this.$router.replace({
            path: '/personalCenter/myIndent',
          });
        }
      } else {
        this.clearStorage();
        sessionStorage.removeItem('giftPageAddress'); // 买赠送会员活动修改，弹窗弹出判断重置。不然没有清空的地方，弹窗只会出一次。
        this.$router.push({
          path: '/indentDetail',
          query: { orderNo: this.$route.query.orderNo },
        });
      }
    },
    // 查询是否有多个直播
    async getCatalog() {
      // 判断退换课不请求直播
      if (this?.source === 1 || this?.source === 3) {
        return;
      }
      // 判断App
      const containCurriculumId = sessionStorage.getItem('containCurriculumId');
      const openCourseId = sessionStorage.getItem('openCourseId', this.openCourseId);
      const res = await reqOpenCourseLive(containCurriculumId, 2);
      if (res.code === 0) {
        this.videoList = res.data;
        this.videoList.forEach(item => {
          Object.assign(item, { courseId: this.productInfo[0].productId });
        });
        this.openLiveRoom(this.videoList, openCourseId);
      }
    },
    // 打开直播
    openLiveRoom(videoList) {
      if (videoList.length > 0) {
        this.showLive = true;
      }
    },
    closeLive() {
      this.showLive = false;
    },
    // 退换课查看售后订单
    checkCourse() {
      this.$router.push({
        path: '/replaceClassDetail',
        query: { orderNo: this.$route.query.orderNo },
      });
    },
    // 退换课查看新订单
    checkOrder() {
      if (this.returnLoad) {
        this.$router.push({ path: '/indentDetail', query: { orderNo: this.returnNewOrder } });
      } else {
        this.$toast('加载中...');
      }
    },
    // 退换课查看新订单
    async checkNewOrder() {
      try {
        const res = await reqReplaceDetail(this.$route.query.orderNo);
        if (res.code === 0 && res.data.newOrderNo) {
          this.returnLoad = true;
          this.returnNewOrder = res.data.newOrderNo;
          this.isContainEbook = res.data.isContainEbook ? 2 : 1;
        } else {
          this.returnLoad = false;
          this.$toast(res.msg);
        }
      } catch (error) {
        this.returnLoad = false;
        this.$toast(error.message);
      }
    },
    clearStorage() {
      sessionStorage.removeItem('containCurriculumId');
      // sessionStorage.removeItem('giftPageAddress');
    },
    // 跳班级群列表
    addGroupList() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goStudyClassGroup', '', false);
      } else {
        this.$toast('请前往App学习中心-班级群进行添加');
      }
    },
    // 买课赠券弹窗关闭
    closeOverlay() {
      this.couponOverlay = false;
    },
    // 查询是否有买课赠券
    async getBuyCourseGift() {
      // this.$route.query.orderNo
      const res = await reqCouponGiftSuc(this.$route.query.orderNo);
      if (res?.code === 0 && res?.data) {
        const { giftCouponRespList, giftMaterialRespList, giftMemberRespList } = res?.data;
        // 优惠券
        this.wholeGiftlist = giftCouponRespList?.length > 0 ? giftCouponRespList : null;
        // 实物
        this.giftMaterialList = giftMaterialRespList?.length > 0 ? giftMaterialRespList : null;
        // 会员
        if (!this.userInfo || (this.userInfo.level !== 20 && this.userInfo.level !== 30)) {
          if (giftMemberRespList?.length > 0) {
            const { giveawayPackageId, memberLevel } = giftMemberRespList[0] || {};
            if (this.userInfo?.level >= 40 && memberLevel >= 40) {
              this.giftMemberList = null;
            } else {
              reqPackageName([giveawayPackageId]).then(res2 => {
                this.giftMemberList = [{ ...giftMemberRespList[0], name: res2.data[0].name }];
              });
            }
          }
        }
        console.log(sessionStorage.getItem('giftPageAddress'), 'chaoba ');
        if (sessionStorage.getItem('giftPageAddress')) {
          this.couponOverlay = false;
        } else if (
          giftCouponRespList?.length ||
          giftMaterialRespList?.length ||
          (giftMemberRespList?.length && this.userInfo.level !== 20 && this.userInfo.level !== 30)
        ) {
          this.couponOverlay = true;
        }
      } else {
        this.couponOverlay = false;
      }
    },
    // 查询订单解锁的题库
    async getSubjectArr() {
      const res = await reqGetSubject(this.$route.query.orderNo);
      if (res?.code === 0 && res?.data?.length > 0) {
        this.subjectArr = res?.data;
      }
    },
    // 基础字段配置
    async getTypeList(level) {
      const { data } = await reqTypeList(
        level === 30 ? 'SENIOR_MEMBER_BENEFI' : 'BASIC_MEMBER_BENEFIT',
      );
      this.profitList = data.map(item => {
        return JSON.parse(item.remark);
      });
    },
    lookProfit() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('closePage');
      } else {
        this.$router.replace({ path: '/personalCenter/member' });
      }
    },
    goBack() {
      this.lookProfit();
    },
    async openEbook() {
      await this.getCourseStartStatus();
      console.log(this.productInfo);
      const { startId } = this.productInfo[0];
      if (!startId) {
        this.$toast('开课中，请稍等');
        return;
      }
      if (this.$root.isApp) {
        if (this.productInfo.length > 1) {
          if (judgmentPlatform() === 'HarmonyOS') {
            this.$toast('当前设备不支持，请更换ios/Android最新版学习');
          } else if (
            (judgmentPlatform() === 'android' && !this.$root.checkVersion('5.8.4')) ||
            (judgmentPlatform() === 'ios' && !this.$root.checkVersion('5.8.6'))
          ) {
            this.$toast('请更新最新版本后开始学习');
          } else {
            this.$sendToApp('goEBookListPage');
          }
        } else {
          if (!this.styleTemplate) {
            const { data } = await reqCourseDetail(this.productInfo[0].productId);
            const { productSkuRespVOList } = data;
            this.styleTemplate = productSkuRespVOList[0].productSkuEbookStyleTemplate;
          }
          if (judgmentPlatform() === 'HarmonyOS') {
            this.$toast('当前设备不支持，请更换ios/Android最新版学习');
          } else if (isEbookShowUpdateToast(this.styleTemplate)) {
            this.$toast('请更新最新版查看该电子书');
          } else {
            this.$sendToApp('goEBookTutorialPage', { userProductId: startId });
          }
        }
      } else if (this.$root.miniprogram) {
        if (this.productInfo.length > 1) {
          wx.miniProgram.navigateTo({
            url: `/eBook/eBookList/index`,
          });
        } else {
          wx.miniProgram.navigateTo({
            url: `/myCourse/eBookLearnPage/index?openCourseId=${startId}`,
          });
        }
      } else if (goApp()) {
        this.$toast('请前往启航教育app查看电子书');
      }
    },
  },
  created() {
    this.$sendToApp('reload', { mode: 1, url: '/ark/personalCenter/member' });
    this.$sendToApp('reload', { mode: 1, url: '/ark/personalCenter/benefits' });
    this.$sendToApp('reload', { mode: 1, url: '/ark/personalCenter/seniorMember' });
    this.$sendToApp('reload', { mode: 1, url: '/mockExam/examZone' });
    this.$sendToApp('reload', { mode: 1, url: '/mockExam/examZonePromotion' });
    this.$sendToApp('reload', { mode: 1, url: '/zhuanti/springUpload' });
  },
};
</script>

<style lang="scss" scoped>
.paySuccess.vip {
  background: #f9f9f9;
}

.paySuccess {
  position: relative;
  flex: 1;
  width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  padding-top: 150px;
  // background: white;
  background: #f7f8fc;
  user-select: none;

  .closeButton {
    position: absolute;
    top: 45px;
    right: 42px;
    width: 31px;
    height: 31px;
    background: url('../../assets/img/payment/dialog_close.png') no-repeat center;
    background-size: contain;
    cursor: pointer;
  }

  .buttonPart {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 51px 67px 0;

    .addCard {
      position: relative;
      width: 616px;
      height: 225px;
      margin-bottom: 29px;
      padding: 23px 0 24px 229px;
      background: url('../../assets/img/payment/add_card_qq.png') no-repeat center center;
      background-size: contain;

      .qrcode {
        position: absolute;
        top: 22px;
        left: 29px;
        width: 181px;
        height: 181px;
      }

      .cardText {
        .cardTitle {
          height: 36px;
          margin-bottom: 7px;
          color: #fff;
          font-weight: 600;
          font-size: 25px;
          line-height: 36px;
          word-break: break-all;
        }

        .cardTips {
          height: 36px;
          margin-bottom: 24px;
          color: #fff;
          font-weight: 400;
          font-size: 24px;
          line-height: 36px;
        }

        .cardTips.mini {
          position: absolute;
          bottom: 0;
          // display: flex;
          // align-items: center;
          max-width: 370px;
          height: auto;
          padding: 7px 22px;
          // line-height: 32px;
          border: 3px dotted #fff;
        }

        .addButton {
          position: absolute;
          bottom: 24px;
          left: 239px;
          padding: 12px 20px 12px 20px;
          color: #ff6b00;
          font-weight: 400;
          font-size: 22px;
          line-height: 24px;
          background: #fff;
          border-radius: 28px;
          cursor: pointer;
        }
      }

      &.addCardWechat {
        background-image: url('../../assets/img/payment/add_card_wechat.png');
      }
    }

    .goCourse {
      height: 58px;
      margin-right: 20px;
      padding: 11px 60px;
      color: #ff6c02;
      font-weight: 400;
      font-size: 25px;
      background: #fff;
      border: 2px solid #ff6c02;
      border-radius: 29px;
      cursor: pointer;
    }

    .bindInfo {
      height: 58px;
      padding: 11px 60px;
      color: #fff;
      font-weight: 400;
      font-size: 24px;
      background: #ff6c02;
      border: 2px solid #ff6c02;
      border-radius: 29px;
      cursor: pointer;
    }
  }

  .recommendPart {
    .recommendTitle {
      height: 45px;
      margin-top: 43px;
      margin-bottom: 29px;
      color: #333;
      font-weight: 600;
      font-size: 33px;
      line-height: 45px;
      text-align: center;
    }
  }

  .courseList {
    margin: 0 34px;
  }

  .errorTips {
    font-size: 28px;
    text-align: center;
  }
}

.inApp {
  padding-top: 90px;
}

.returnClass {
  .sIcon {
    width: 109px;
    height: 109px;
    margin: 0 auto;
    background: url('../../assets/img/payment/pay_success.png') no-repeat center;
    background-size: contain;
  }

  p {
    margin: 60px auto;
    color: #787878;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
    text-align: center;
  }

  .checkCourse {
    display: block;
    height: 58px;
    margin: 60px auto 0;
    padding: 11px 40px;
    color: #333;
    font-weight: 400;
    font-size: 25px;
    background-color: transparent;
    cursor: pointer;
  }

  .checkOrder {
    display: block;
    height: 58px;
    margin: 0 auto;
    padding: 11px 40px;
    color: #fff;
    font-weight: 400;
    font-size: 25px;
    background-color: #ff6c02;
    border-radius: 29px;
    cursor: pointer;
  }
}

.form22 {
  margin: 40px;

  .title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 0 32px;

    img {
      width: 40px;
      height: 40px;
    }

    span {
      padding: 2px 0 0 5px;
      color: #333;
      font-weight: 600;
      font-size: 32px;
    }
  }

  .form22-box {
    padding: 32px;
    border: 2px solid #f5f5f5;
    border-radius: 8px;

    .txt-box {
      h2 {
        padding: 16px 0 16px 0;
        color: #333;
        font-weight: 500;
        font-size: 28px;
      }

      p {
        padding: 0 0 32px 0;
        color: #787878;
        font-size: 28px;
        line-height: 40px;
      }

      .border {
        border-bottom: 1px solid #f6f6f6;
      }
    }
  }
}

.learningToRemind {
  margin: 62px 36px;

  .title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 0 32px;

    img {
      width: 36px;
      height: 36px;
    }

    span {
      padding: 2px 0 0 5px;
      color: #333;
      font-weight: 600;
      font-size: 29px;
    }
  }

  .addRingGroup {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 261px;
    background: linear-gradient(47deg, #fff9f7 0%, #fff2ec 100%);
    border-radius: 7px;

    img.bgImg {
      position: absolute;
      right: 22px;
      bottom: 0;
      width: 168px;
      height: 152px;
    }

    > div {
      h2 {
        color: #333;
        font-weight: 500;
        font-size: 25px;
        line-height: 36px;
      }

      h3 {
        width: 225px;
        height: 58px;
        margin: 36px auto 0 auto;
        color: #fff;
        font-weight: 400;
        font-size: 25px;
        line-height: 58px;
        text-align: center;
        background: #fe7f41;
        border-radius: 29px;
      }
    }
  }
}

.member_empty_icon {
  display: block;
  width: 678px;
  height: 145px;
  margin: 51px auto 0;
}

.like_icon {
  display: block;
  width: 232px;
  height: 53px;
  margin: 72px auto 0;
}

.like_list {
  margin-top: 22px;
  padding-bottom: 36px;
}

.vip-container {
  background: #f9f9f9;

  .status {
    img {
      display: block;
      width: 127px;
      height: 127px;
      margin: 0 auto;
    }

    p {
      margin-top: 22px;
      color: #333;
      font-weight: 600;
      font-size: 29px;
      line-height: 40px;
      text-align: center;
    }
  }

  .profit {
    width: 678px;
    margin: 72px auto 0;
    padding-bottom: 43px;
    // height: 553px;
    background: #fff;
    border-radius: 14px;

    h2 {
      padding: 43px 0;
      color: #ff7f41;
      font-weight: 500;
      font-size: 29px;
      text-align: center;
    }

    .list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding: 0 0 0 33px;

      div {
        margin-right: 42px;
        margin-bottom: 22px;

        img {
          display: block;
          width: 72px;
          height: 72px;
          margin: 0 auto;
        }

        p {
          padding-top: 11px;
          color: #333;
          font-weight: 400;
          font-size: 22px;
          text-align: center;
        }
      }

      div:nth-child(5n) {
        margin-right: 0;
      }
    }
  }

  .vip-shequn-code {
    width: 616px;
    height: 225px;
    margin: 49px auto 0;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/member/member_paySucc_shequn.png');

    .code {
      float: left;
      width: 181px;
      height: 181px;
      margin-top: 22px;
      margin-left: 29px;
      padding-top: 7px;
      padding-left: 7px;
      background: white;

      img {
        width: 163px;
        height: 167px;
      }
    }

    .content {
      float: left;
      margin-top: 31px;
      margin-left: 22px;
      overflow: hidden;

      .title {
        height: 36px;
        color: #fff;
        font-weight: 600;
        font-size: 25px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        line-height: 36px;
      }

      .info {
        height: 36px;
        margin-top: 7px;
        color: #fff;
        font-weight: 600;
        font-size: 25px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        line-height: 36px;
      }

      .tip {
        width: 275px;
        height: 56px;
        margin-top: 34px;

        img {
          display: block;
          width: 275px;
          height: 56px;
        }

        // background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/member/member_paySucc_shequn_tip.png');
      }

      .tipApp {
        width: 359px;
        height: 56px;
        margin-top: 34px;

        img {
          display: block;
          width: 359px;
          height: 56px;
        }
      }
    }
  }

  .lookProfit {
    display: block;
    height: 60px;
    margin: 72px auto 0;
    padding: 11px 40px;
    color: #fff;
    font-weight: 400;
    font-size: 25px;
    background-color: #ff6c02;
    border-radius: 29px;
    cursor: pointer;
  }
}

.ebook {
  text-align: center;

  img {
    width: 109px;
  }

  .msg {
    padding: 29px 0 100px 0;
    color: #333;
    font-weight: 600;
    font-size: 29px;
    text-align: center;
  }

  .lookBook {
    width: 283px;
    height: 80px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background-color: #ff6c02;
    border-radius: 41px;
    cursor: pointer;
  }
}
.zsb {
  padding-top: 100px;
  text-align: center;
  img {
    width: 109px;
    height: 109px;
  }
  p {
    padding: 29px 0 80px 0;
    color: #333;
    font-weight: 600;
    font-size: 29px;
  }
  button {
    width: 283px;
    height: 80px;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #ff7f41;
    border: none;
    border-radius: 41px;
  }
}
</style>
